import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Meditation from "./pages/Meditation";
import Chakras from "./pages/Chakras";
import Benefits from "./pages/Benefits";
import Contact from "./pages/Contact";
import DonationPage from "./pages/DonationPage";
import ShriMataji from "./pages/ShriMataji";
import FloatingDonateButton from "./components/FloatingDonateButton";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "react-hot-toast"; // ✅ Toast provider
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen overflow-x-hidden">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/meditation" element={<Meditation />} />
            <Route path="/chakras" element={<Chakras />} />
            <Route path="/benefits" element={<Benefits />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/donate" element={<DonationPage />} />
            <Route path="/shrimataji" element={<ShriMataji />} />

            {/* 404 Route */}
            <Route
              path="*"
              element={
                <div className="text-center py-24 px-6">
                  <h2 className="text-3xl font-bold text-green-800 mb-4">404 - Page Not Found</h2>
                  <p className="text-gray-600 mb-6">
                    The page you're looking for doesn't exist or has been moved.
                  </p>
                  <Link
                    to="/"
                    className="inline-block bg-green-700 hover:bg-green-800 text-white font-medium px-6 py-3 rounded-full transition"
                  >
                    Back to Home
                  </Link>
                </div>
              }
            />
          </Routes>
        </main>
        <Footer />
        <FloatingDonateButton />
        <Toaster position="top-center" toastOptions={{ duration: 3000 }} />
      </div>
    </Router>
  );
}

export default App;
